import { render } from "./otherList.vue?vue&type=template&id=17e56653&scoped=true&ts=true"
import script from "./otherList.vue?vue&type=script&lang=ts"
export * from "./otherList.vue?vue&type=script&lang=ts"

import "./otherList.vue?vue&type=style&index=0&id=17e56653&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17e56653"]])

export default __exports__